import { render, staticRenderFns } from "./LevelTabs.vue?vue&type=template&id=4031678e&scoped=true&"
import script from "./LevelTabs.vue?vue&type=script&lang=js&"
export * from "./LevelTabs.vue?vue&type=script&lang=js&"
import style0 from "./LevelTabs.vue?vue&type=style&index=0&id=4031678e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031678e",
  null
  
)

export default component.exports